module.exports = __webpack_public_path__ + "static/flags/RO-1ecb86e88084cb306b1308b3b887db19.gif";